import { PropsWithChildren } from 'react'
import { Schemas } from '~/api/gen'
import { VisibilityIcon } from '~/components/icons/generated/VisibilityIcon'
import { FolderImages } from './FolderImages'

type FolderItemProps = {
  userName: string
  folder: Schemas.folder_collection_with_folder_elements
  imagePriority?: boolean
}
export const FolderItem: React.FC<FolderItemProps> = ({
  userName,
  folder,
  imagePriority,
}) => {
  return (
    <>
      <a
        href={`/${userName}/favorite/${folder.id}/`}
        className="xl:hover:opacity-70"
      >
        <div className="relative">
          <FolderImages
            folderImageUrls={folder.folder_elements
              .map(({ image }) => {
                return image?.url_125
              })
              .filter((image) => image !== undefined)}
            imagePriority={imagePriority}
          />
          {folder.folder_aggregate?.view_count !== 0 && (
            <div className="absolute bottom-1 left-[5px] flex items-center gap-x-1 rounded-[3px] bg-black/60 px-2 py-[3px] text-[11px] leading-[1.2] text-white xl:bottom-2 xl:left-[6px] xl:px-[6px] xl:py-1 xl:text-[13px]">
              <VisibilityIcon className="h-3 xl:h-[13px]" />
              {folder.folder_aggregate?.view_count}
            </div>
          )}
        </div>
      </a>
      <div className="xl:flex xl:flex-col xl:gap-y-[7px] xl:px-[18px] xl:pb-[10px] xl:pt-[14px]">
        <h2 className="truncate pt-[5px] text-xs font-bold xl:whitespace-normal xl:pt-0 xl:text-[18px] xl:leading-[1.3]">
          {folder.name}
        </h2>
        <div className="pt-[2px] text-xs font-bold xl:text-[15px]">
          {folder.folder_aggregate?.active_element_count ?? 0}件
        </div>
      </div>
    </>
  )
}

export const Folders: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <ul className="grid grid-cols-2 gap-x-3 gap-y-2 xl:grid-cols-3 xl:items-start xl:gap-x-[21px] xl:gap-y-5">
      {children}
    </ul>
  )
}
